import { api } from "..";
import { QueryProps } from "@/types/Api";
import { ChatsResponse, GetChatsParams } from "./types";

export const getChats = async (
  props: QueryProps<GetChatsParams>
): Promise<ChatsResponse> => {
  const res = await api.client.get("/chats", {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
